import { UploadApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const uploadApi = new UploadApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
